export default __webpack_public_path__ + "static/tbe-87444dd697a0675662e1e03b471dcc8b.png";